import { API_ROUTES } from '@app/common';
import type {
  ActivityLogEntry,
  ActivityType,
  AdminStats,
  AdminUserSummary,
  Paginated,
} from '@app/common';
import { apiFetch } from './index';

export type {
  ActivityLogEntry,
  ActivityType,
  AdminStats,
  AdminUserSummary,
  Paginated,
} from '@app/common';

/** Drops empty values so the backend's Zod defaults apply instead of receiving `""`. */
function toQuery(params: Record<string, string | number | undefined>): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== '') search.set(key, String(value));
  }
  const query = search.toString();
  return query ? `?${query}` : '';
}

export const listUsers = (params: {
  page?: number;
  pageSize?: number;
  search?: string;
}): Promise<Paginated<AdminUserSummary>> =>
  apiFetch<Paginated<AdminUserSummary>>(`${API_ROUTES.ADMIN_USERS}${toQuery(params)}`);

export const listActivity = (params: {
  page?: number;
  pageSize?: number;
  userId?: string;
  type?: ActivityType;
  from?: string;
  to?: string;
}): Promise<Paginated<ActivityLogEntry>> =>
  apiFetch<Paginated<ActivityLogEntry>>(`${API_ROUTES.ADMIN_ACTIVITY}${toQuery(params)}`);

export const getStats = (days = 30): Promise<AdminStats> =>
  apiFetch<AdminStats>(`${API_ROUTES.ADMIN_STATS}${toQuery({ days })}`);
